export const TOPICS_RECEIVED = "topics_received";
export const TOPIC_DETAILS_RECEIVED = "topic_details_received";